module.exports = __webpack_public_path__ + "static/img/27.7f0c14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/27.png
// module id = f5Jp
// module chunks = 0